function createCompany(customerId, company, first_name, last_name, street, number, city, zone_code, zip) {
    const url = baseUrl + "2024-10/graphql.json";
    //    const url = "/admin/api/2024-10/graphql.json";

    const query = `
        mutation CompanyCreate($input: CompanyCreateInput!) { 
            companyCreate(input: $input) { 
            company { 
                id 
                name 
                externalId 
                mainContact { 
                id 
                customer { 
                    id 
                    email 
                    firstName 
                    lastName 
                } 
                } 
                contacts(first: 5) { 
                edges { 
                    node { 
                    id 
                    customer { 
                        email 
                        firstName 
                        lastName 
                    } 
                    } 
                } 
                } 
                contactRoles(first: 5) { 
                edges { 
                    node { 
                    id 
                    name 
                    } 
                } 
                } 
                locations(first: 5) { 
                edges { 
                    node { 
                    id 
                    name 
                    shippingAddress { 
                        firstName 
                        lastName 
                        address1 
                        city 
                        province 
                        zip 
                        country 
                    } 
                    } 
                } 
                } 
            } 
            userErrors { 
                field 
                message 
                code 
            } 
            } 
        }
        `;

    const variables = {
        input: {
            company: {
                name: company + " - " + first_name,
                externalId: ""
            },
            companyLocation: {
                name: "Localização - " + zone_code,
                shippingAddress: {
                    firstName: first_name,
                    lastName: last_name,
                    address1: street,
                    address2: number,
                    city: city,
                    zoneCode: zone_code,
                    zip: zip,
                    countryCode: "BR"
                },
                billingSameAsShipping: true

            },
            companyContact: {}

        }
    };

    fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "apikey": apiPassword
        },
        body: JSON.stringify({
            query,
            variables
        })
    })
        .then(response => response.json())
        .then(data => {
            console.log("Empresa criada", data);
            console.log("Empresa ID", data.data.companyCreate);
            const companyId = data?.data?.companyCreate?.company?.id;
            const locationId = data?.data?.companyCreate?.company?.locations?.edges?.[0]?.node?.id;
            joinCompanyAndCustomer(companyId, customerId, locationId);
        })
        .catch(error => console.error("Error:", error));

}